import { Identifier } from "../../core";
export class CustomParameterChoiceId extends Identifier {
    constructor(id) {
        super("CustomParameterChoiceId", id);
    }
}
